import isEmail from 'validator/es/lib/isEmail';
import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { RuleArgs } from '.';

export const emailRule = ({ required }: RuleArgs): Rule => {
  const { t } = useTranslation();

  return ({
    required,
    message: t('Please enter correct email'),
    validator: (_, value: string) => (
      (!required && !value) || isEmail(value)
        ? Promise.resolve()
        : Promise.reject()
    ),
  });
};
